// extracted by mini-css-extract-plugin
module.exports = {"root":"BundleOptions_root__1Rq_S"};